export default {
    namespaced:"userOptions",
    actions:{
       saveUserInfo(context,value){
           context.commit("SAVE_USER_INFO",value)
       }
    },
    mutations:{
        SAVE_USER_INFO(state,value){
            state.userInfo = value
            if (value) {
                // 设置过期时间为7天
                const expireTime = new Date().getTime() + (7 * 24 * 60 * 60 * 1000);
                const storageData = {
                    userInfo: value,
                    expireTime: expireTime
                };
                localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(storageData));
            } else {
                // 如果value为null（退出登录），清除localStorage
                localStorage.removeItem(process.env.VUE_APP_USER_KEY);
            }
        }
    },
    state:{
        userInfo: (() => {
            try {
                const storageData = localStorage.getItem(process.env.VUE_APP_USER_KEY);
                if (storageData) {
                    const parsed = JSON.parse(storageData);
                    // 检查是否有过期时间设置
                    if (parsed.expireTime) {
                        // 检查是否过期
                        if (new Date().getTime() > parsed.expireTime) {
                            // 已过期，清除数据
                            localStorage.removeItem(process.env.VUE_APP_USER_KEY);
                            return null;
                        }
                        return parsed.userInfo;
                    } else {
                        // 兼容旧数据格式
                        return parsed;
                    }
                }
                return null;
            } catch (error) {
                console.error('解析用户信息失败:', error);
                localStorage.removeItem(process.env.VUE_APP_USER_KEY);
                return null;
            }
        })()
    },
}
